<template>
  <v-container>
    <v-layout>
        <v-flex lg8 mx-auto>
            <v-card class="pa-6 mx-auto justify-center mt-12 elevation-13">
                <v-card-title class="display-2 text--primary justify-center font-weight-black"><p class="orange--text">{{ $t('contact.contactInformation') }}</p></v-card-title>
                <v-card-text>
                    <v-simple-table>
                    <template>
                      <tbody>
                        <tr>
                          <td class="orange--text font-weight-bold">{{ $t('contact.address') }}</td>
                          <td>{{ $t('contact.limoTourAddress') }}</td>
                        </tr>
                        <tr>
                          <td class="orange--text font-weight-bold">{{ $t('contact.telephone') }}</td>
                          <td>(051) 747-2040</td>
                        </tr>
                        <tr>
                          <td class="orange--text font-weight-bold">{{ $t('contact.fax') }}</td>
                          <td>(051) 731-2049</td>
                        </tr>
                        <tr>
                          <td class="orange--text font-weight-bold">{{ $t('contact.email') }}</td>
                          <td>booking@limotourkorea.com</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
              </v-card>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ContactMain',
  data: () => ({
  }),
};
</script>

<style scoped>
</style>
